
import Login from '../../Components/Server/Login';
const LoginPage = () => {
  return <>
   <Login />
  </>
}
export default LoginPage;